import { Institution } from './Institution'; 
import { SiteEnum } from './enums/SiteEnum';
import { BrugerRolleEnum } from './enums/BrugerRolleEnum';
export class Bruger {
        public id: string;
        public navn: string;
        public brugernavn: string;
        public accepteretVilkaar: boolean;
        public email: string;
        public gruppeId: string;
        public institutionId: string;
        public institutionsNummer: string;
        public site: SiteEnum;
        public rolle: BrugerRolleEnum;
        public institutioner: Institution[];
}   



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/Bruger.ts